module.exports = __webpack_public_path__ + "images/logo-coca-cola.svg";